/**
* Top bar sticky
* !!!!!REFACTORING NEEDED!!!!!
**/
;var topBar = (function ($, window) {
    
    var topbar = function ($target, options) {
        
        /**
        * Set local variables
        */
        var config = {
    		fixedClass: 'is--fixed'
	    }; 
    
        this.$target = $target; //is obj
        this.options = $.extend(true, config, options);
        this.dataObj=[]; //data array for stiky obj
        
        //call _init function
        this._init();
    };

    topbar.prototype._init = function() {
        var self=this;
    
		this.dataObj = this._getData();
        
        	//get new offset etc when document resize
		$(window).resize(function() {
	        if(this.resizeTO) 
	    	    clearTimeout(this.resizeTO);
	    
            this.resizeTO = setTimeout(function() {
	            $(this).trigger('resizeEnd');
            }, 500);
        });
		
		$(window).bind('resizeEnd', function() {
    	    self.dataObj=self._getData();
		});
        
        
        $(window).bind('scroll',function() {
            //console.log(self.dataObj);

            $.each(self.dataObj, function(index) {
                self._updateBar(this[0], this[1], this[2]);//obj,top,bottom,offset
            });
        });
    };
    
    
    topbar.prototype._updateBar = function(obj, top, bottom) {
        var window_top = $(window).scrollTop(),
            self = this;
	
		
		if (window_top > top && window_top <= bottom) {
			obj
                .addClass('animation-out')
                .removeClass('is--fixed');
				
				
		} else if (window_top <= top) {
			obj
			    .removeClass('animation-out')
				.removeClass('is--fixed');
				
				
		} else if (window_top > bottom) {
			obj
			    .removeClass('animation-out')
				.addClass('is--fixed');
		}  
    };
    
    
    topbar.prototype._getData = function() {
        var self=this,
            itemArray=[];

			var obj = $(self.$target),
				top = $(self.options.startScroll).offset().top,
				bottom = $(self.options.endScroll).outerHeight() + top;
			
            itemArray.push([obj,top,bottom]);	
            //console.log(itemArray);
		return itemArray;
    };
    
    /**
     * On DOM ready
     */
    $(function () {
        /**
        * initialize toggle object function
        */
        var initTopbar = function () {

            $('[data-window-scroll]').each(function () {

                var $target = $(this),
                    options = $target.data('window-scroll');
                
                new topbar($target, options);
            });
        };
       
        initTopbar();
    });

})(jQuery, window);